module.exports = __webpack_public_path__ + "img/guadalajara-sur.596649f8.jpg";